import { useEffect } from 'react';
import api from '../utils/api';

export const ACADEMIC_YEAR_KEY = 'selected_academic_year_id';

export function syncAcademicYearToLocalStorage(schoolId, academicYearId) {
  if (!schoolId || !academicYearId) return;
  const value = String(academicYearId);
  localStorage.setItem(`${ACADEMIC_YEAR_KEY}_${schoolId}`, value);
  window.dispatchEvent(new CustomEvent('academicYearChanged', { detail: { schoolId, academicYearId: value } }));
}

export default function useAcademicYearBootstrap(schoolId) {
  useEffect(() => {
    if (!schoolId) return undefined;

    const storageKey = `${ACADEMIC_YEAR_KEY}_${schoolId}`;
    const saved = localStorage.getItem(storageKey);
    let cancelled = false;

    api.get('/settings/academic-years', { params: { school_id: schoolId } })
      .then((res) => {
        if (cancelled) return;
        const years = res.data.data || [];
        if (!saved && years.length > 0) {
          const current = years.find((y) => y.is_current);
          const id = (current || years[0]).id.toString();
          localStorage.setItem(storageKey, id);
        }
      })
      .catch(() => {});

    return () => { cancelled = true; };
  }, [schoolId]);
}
